import React from 'react';

const Block = ({ html, className }) => <div className={`html-block ${className || ''}`} dangerouslySetInnerHTML={{ __html: html }} />;

export default Block;
